import { CLARITY_MODEL_FAMILY_DISPLAY_NAME, type ClarityModelFamily } from './constants/clarity-model-family.constant';

/**
 * `Object.hasOwn`, never `in`: `in` walks the prototype chain, so a backend value of `'toString'` or
 * `'constructor'` would test as a known family and render a function body into the admin UI.
 */
function isKnownFamily(value: string): value is ClarityModelFamily {
	return Object.hasOwn(CLARITY_MODEL_FAMILY_DISPLAY_NAME, value);
}

/**
 * Pretty label for a model family — `'opus'` → `'Claude Opus'`.
 *
 * An unknown value passes through unchanged rather than becoming a placeholder, so an admin sees
 * whatever the backend actually returned instead of losing the information to the UI.
 *
 * Ported from Clarity `apps/web/src/shared/utils/modelFamilyUtils.ts`.
 */
export function formatModelFamilyLabel(value: string): string {
	if (isKnownFamily(value)) {
		return `Claude ${CLARITY_MODEL_FAMILY_DISPLAY_NAME[value]}`;
	}

	return value;
}
